import {
  Spinner,
  MessageBar,
  MessageBarType,
  Dialog,
  DialogFooter,
  DialogType,
  DefaultButton,
  PrimaryButton,
} from '@fluentui/react';
import {useState} from 'react';
import commonStyles from '../../common/commonStyles.module.scss';
import {Subscription} from '../../Swagger/api';
import {getApis} from '../../webservices';

interface ICancelSubscription {
  onDone: () => void;
  onCancel: () => void;
  subscription: Subscription;
}

export const CancelSubscription = (props: ICancelSubscription) => {
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const onDelete = async () => {
    setLoading(true);
    setHasError(false);

    try {
      const {subscriptionClient} = await getApis();
      await subscriptionClient.removeSubscription(props.subscription.id);
      props.onDone();
    } catch {
      setHasError(true);
      setLoading(false);
    }
  };

  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        subText:
          'Canceling the subscription will remove the entire data of the subscription. The data can not be recovered. Are you sure?',
        title: 'Cancel subscription',
        type: DialogType.normal,
      }}
      modalProps={{
        isBlocking: true,
      }}
      minWidth="40em"
      onDismiss={props.onCancel}
    >
      <DialogFooter>
        <section className={commonStyles.dialogMessages}>
          {loading ? (
            <Spinner
              className={commonStyles.spinner}
              label="Please wait"
              ariaLive="assertive"
              labelPosition="right"
            />
          ) : null}
          {hasError ? (
            <MessageBar
              className={commonStyles.messageBar}
              messageBarType={MessageBarType.error}
              isMultiline={true}
              dismissButtonAriaLabel="Close"
            >
              Something went wrong. Please try again or contact an
              Administrator.
            </MessageBar>
          ) : null}
        </section>
        <PrimaryButton onClick={onDelete} text="Remove" />
        <DefaultButton onClick={props.onCancel} text="Cancel" />
      </DialogFooter>
    </Dialog>
  );
};
